module.exports = __webpack_public_path__ + "img/marie-laure-chamorel.1e3786fa.webp";